import { render, staticRenderFns } from "./HousingPicture.vue?vue&type=template&id=63534a30&scoped=true"
import script from "./HousingPicture.vue?vue&type=script&lang=js"
export * from "./HousingPicture.vue?vue&type=script&lang=js"
import style0 from "./HousingPicture.vue?vue&type=style&index=0&id=63534a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63534a30",
  null
  
)

export default component.exports